<template>
    <div>
      <div
        :class="
          `${widthClass} ${heightClass} relative`
        "
      >
        
        <div
          :class="
            `block text-base-content/10 hover:text-base-content/25 ${
              isEditable ? 'x-hoverable' : ''
            } h-full w-full relative z-10`
          "
        >
          <div v-if="imageUrl || localImageUrl" class="x-upload-image h-full">
            <div class="x-overlay">
              <svg
                class="x-overlay-icon"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"
                />
              </svg>
            </div>
            <img
              draggable="false"
              :src="thumbnailUrl || imageUrl || localImageUrl"
              :class="[
                sizing == 'cover' ? 'object-cover' : 'object-contain',
                `h-full w-full block ${paddingClass} ${imageClass}`
              ]"
            />
          </div>
          <div class="flex items-center h-full justify-center" v-else>
            <v-icon name="bi-card-image" scale="5" />
          </div>
        </div>
        <!-- <div class="fixed h-full w-full z-1 top-0 left-0 opacity-20">
          <img src="@/assets/images/liquid-wave.svg"/>
        </div> -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      imageClass: {
        type: String,
        default: ''
      },
      sizing: {
        type: String,
        default: 'contain'
      },
      widthClass: {
        type: String,
        default: 'w-24'
      },
      heightClass: {
        type: String,
        default: 'h-24',
      },
      blankWidth: {
        type: Number
      },
      blankHeight: {
        type: Number
      },
      paddingClass: {
        type: String,
        default: ''
      },
      editableOnlyWhenEmpty: {
        type: Boolean,
        default: false
      },
      editable: {
        type: Boolean,
        default: true
      },
      imageUrl: {
        validator: prop => typeof prop === 'string' || prop === null,
        required: true
      },
      thumbnailUrl: {
        type: String
      },
      showLoader: {
        type: Boolean,
        default: false
      },
      value: {}
    },
    data() {
      return {
        file: null,
        localImageUrl: null,
        fileSizeExceedsLimit: false,
        fileTypeNotAllowed: false,
        fileSizeLimit: 3
      }
    },
    computed: {
      isEditable() {
        return (
          this.editable &&
          (!this.imageUrl || (!this.editableOnlyWhenEmpty && this.imageUrl))
        )
      }
    },
    methods: {
      onImageChange(event) {
        this.fileSizeExceedsLimit = false
        this.fileTypeNotAllowed = false
  
        let files = event.target.files || event.dataTransfer.files
        const reader = new FileReader()
  
        reader.addEventListener(
          'load',
          () => {
            this.localImageUrl = reader.result
            this.$emit('update:imageUrl', reader.result)
          },
          false
        )
  
        if (files[0]) {
          //check file size
          const fileSizeInBytes = files[0].size
          const maxSizeInBytes = this.fileSizeLimit * 1024 * 1024
  
          if (fileSizeInBytes > maxSizeInBytes) {
            this.fileSizeExceedsLimit = true
            return
          }
  
          //check file type
          if (files[0].type !== 'image/webp' && files[0].type !== 'image/png') {
            this.fileTypeNotAllowed = true
            return
          }
  
          this.file = files[0]
          reader.readAsDataURL(files[0])
          this.$emit('update:file', files[0])
        }
      }
    }
  }
  </script>
  
  <style scoped>
  /* .div-level-1 {
    background-color: #c7c1c1;
  } */
  .x-upload-image {
    @apply relative object-contain w-full;
  }
  .x-overlay {
    @apply absolute h-full w-full hidden items-center text-center text-base-100;
    background: oklch(var(--b3) / 0.75);
  }
  .x-overlay > .x-overlay-icon {
    width: 35%;
    margin: auto;
  }
  </style>
  